import { useQuery } from '@tanstack/react-query';
import { getPageMeta } from '../services/seoService.js';

export default function usePageSeo(path) {
  const { data } = useQuery({
    queryKey: ['seo-meta', path],
    queryFn: () => getPageMeta(path),
    enabled: !!path,
    staleTime: 0,
    retry: 0,
  });
  return data?.data || null;
}
